import { typeCreatorV2 } from 'redux/utils/common';

//  [REDUCER][TYPE]
export const SET_NEWS_LIST: string = typeCreatorV2(
  'NewsReducer',
  'SetNewsList'
);

export const SET_ADD_NEWS: string = typeCreatorV2('NewsReducer', 'SetAddNews');

export const SET_EDIT_NEWS: string = typeCreatorV2(
  'NewsReducer',
  'SetEditNews'
);

export const SET_NEWS_DETAIL: string = typeCreatorV2(
  'NewsReducer',
  'SetNewsDetail'
);

export const SET_SEGMENTS: string = typeCreatorV2('NewsReducer', 'SetSegments');
export const UPDATE_TITLE_TEMPORARY: string = typeCreatorV2(
  'NewsReducer',
  'UpdateTitleTemporary'
);
export const UPDATE_SHORT_TEMPORARY: string = typeCreatorV2(
  'NewsReducer',
  'UpdateShortTemporary'
);
export const UPDATE_FULL_TEMPORARY: string = typeCreatorV2(
  'NewsReducer',
  'UpdateFullTemporary'
);
